import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, IconButton, useMediaQuery, useTheme,
} from '@mui/material';

function DefaultCPButton({
  content, onClick, disabled, icon,
  color,
}) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  if (matches) {
    return (
      <Button
        variant="outlined"
        startIcon={icon}
        onClick={onClick}
        disabled={disabled}
        size="small"
        color={color}
        sx={{ whiteSpace: 'nowrap' }}
      >
        {content}
      </Button>
    );
  }
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      size="small"
      color={color}
      sx={{ border: 1, borderRadius: 1 }}
      title={content}
    >
      {icon}
    </IconButton>
  );
}

DefaultCPButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  color: PropTypes.string,
};

DefaultCPButton.defaultProps = {
  content: '',
  disabled: false,
  icon: null,
  color: 'primary',
};

export default DefaultCPButton;
